import React from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import { AppConfig } from "../../../../../common/constants";
import "../../../../../App.css";
import "../../projectdetail.css";
import { ISimulatorRow } from "../../../../../webapi/service/getSimulator";
import { IFileRow } from "../../../../../webapi/service/getFIles";

export interface IProps extends WithTranslation {
  /**
   * タイトル
   */
  title: string;
  /**
   * 見出し
   */
  caption: string;
  /**
   * ダイアログを表示する場合はtrue
   */
  show: boolean;
  /**
   * シミュレータ情報一覧
   */
  simulators: ISimulatorRow[];
  /**
   * ファイル情報一覧
   */
  files: IFileRow[];
  /**
   * OKボタンが押された場合に呼び出されます
   */
  onOk: (step: boolean, impulse: boolean, files?: string[]) => void;
  /**
   * キャンセルボタンが押された場合に呼び出されます
   */
  onCancel: () => void;
}

interface ICheckItem {
  /**
   * ID
   */
  checkid: string;
  /**
   * チェックがONの場合はtrue
   */
  checked: boolean;
}

interface IState {
  /**
   * チェック項目一覧
   */
  checkItems: ICheckItem[];
  /**
   * stepでのシミュレーションの有無
   */
  step: boolean;
  /**
   * impulseでのシミュレーションの有無
   */
  impulse: boolean;
}

class SimulatorSettingDialog extends React.Component<IProps, IState> {
  private readonly max_files = AppConfig.MAX_SIM_SIMULATION;

  constructor(props: IProps) {
    super(props);

    this.state = { checkItems: [], step: false, impulse: false };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClickCancel = this.handleClickCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeStep = this.handleChangeStep.bind(this);
    this.handleChangeImpulse = this.handleChangeImpulse.bind(this);
  }

  componentDidUpdate(prevProps: IProps) {
    const { files } = this.props;
    const { checkItems } = this.state;
    if (
      (checkItems.length === 0 && files.length > 0) ||
      files.length !== prevProps.files.length
    ) {
      const checkItems = files.map((file) => {
        return {
          checkid: file.fileid,
          checked: false,
        };
      });
      this.setState({ checkItems: checkItems });
    }
  }

  handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const checkItems = this.state.checkItems.filter((item) => {
      return item.checked === true;
    });
    const files = checkItems.map((item) => {
      return item.checkid;
    });
    this.setState({ checkItems: [] });
    this.props.onOk(this.state.step, this.state.impulse, files);
  }

  handleClickCancel() {
    this.setState({ checkItems: [], step: false, impulse: false });
    this.props.onCancel();
  }

  handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const id = e.target.id;
    const checked = e.target.checked;
    const checkItems = this.state.checkItems.slice();
    checkItems.forEach((item) => {
      if (id === item.checkid) {
        item.checked = checked;
      }
    });
    this.setState({ checkItems: checkItems });
  }

  handleChangeStep(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ step: e.target.checked });
  }

  handleChangeImpulse(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ impulse: e.target.checked });
  }

  render() {
    const { files, t } = this.props;
    const { checkItems } = this.state;
    if (checkItems.length === 0) {
      this.setState({ checkItems: checkItems });
    }
    const checkedItems = checkItems.filter((item) => {
      return item.checked === true;
    });
    //5つまで選択できること、選択数の表示/非表示切り替え
    const caption2 =
      files.length > this.max_files ? t("simulator_simulation_caption2") : "";
    const countCaption =
      files.length > this.max_files
        ? " ( " + checkedItems.length + " / " + this.max_files + " ) "
        : "";
    const fileList = files.map((file, i) => {
      const checkItem = checkItems.find((item) => {
        return item.checkid === file.fileid;
      });
      const check = checkItem ? (
        <Form.Check
          id={checkItem.checkid}
          checked={checkItem.checked}
          onChange={this.handleChange}
        ></Form.Check>
      ) : (
        ""
      );
      return (
        <tr key={i++}>
          <td>{check}</td>
          <td className="item-tagid">{file.name}</td>
          <td className="item-create">{file.inchnum}</td>
          <td className="item-create">{file.outchnum}</td>
          <td className="item-create">{file.datanum}</td>
          <td className="item-create">{file.interval}</td>
        </tr>
      );
    });
    const sisetting = (
      <Form>
        <Form.Check
          label={t("simulator_simulation_si_step")}
          id="step"
          checked={this.state.step}
          onChange={this.handleChangeStep}
        />
        <Form.Check
          label={t("simulator_simulation_si_impulse")}
          id="impulse"
          checked={this.state.impulse}
          onChange={this.handleChangeImpulse}
        />
      </Form>
    );
    const okBtn =
      (0 < checkedItems.length || this.state.step || this.state.impulse) &&
      checkedItems.length <= this.max_files ? (
        <Button className="dialog-button" variant="primary" type="submit">
          {t("prompt_ok")}
        </Button>
      ) : (
        <Button
          className="dialog-button"
          variant="primary"
          type="submit"
          disabled
        >
          {t("prompt_ok")}
        </Button>
      );
    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClickCancel}
        animation={false}
        dialogClassName="channelsetting-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="dialog-caption">{t("simulator_simulation_si")}</div>
            <div className="dialog-checkitem">{sisetting}</div>
            <div className="dialog-caption">
              {t("simulator_simulation_compare")}
            </div>
            <div>{this.props.caption}</div>
            <div>
              <span>{caption2}</span>
              <span>{countCaption}</span>
            </div>
          </div>
          <Form onSubmit={this.handleSubmit}>
            <div className="channelsetting">
              <table>
                <thead>
                  <tr>
                    <th className="create">
                      {t("simulator_simulation_select")}
                    </th>
                    <th className="tagid">{t("simulator_simulation_name")}</th>
                    <th className="create">
                      {t("simulator_simulation_inputnum")}
                    </th>
                    <th className="create">
                      {t("simulator_simulation_outputnum")}
                    </th>
                    <th className="create">
                      {t("simulator_simulation_datanum")}
                    </th>
                    <th className="tagid">
                      {t("simulator_simulation_interval")}
                    </th>
                  </tr>
                </thead>
                <tbody>{fileList}</tbody>
              </table>
            </div>
            <div className="dialog-buttons">
              {okBtn}
              <Button
                className="dialog-button"
                variant="secondary"
                onClick={this.handleClickCancel}
              >
                {t("prompt_cancel")}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

/**
 * シミュレータシミュレーション時の比較ファイル選択ダイアログ
 */
export default withTranslation()(SimulatorSettingDialog);
